import SetInboxAndSweepRulesResponse from 'owa-service/lib/contract/SetInboxAndSweepRulesResponse';
import SetInboxAndSweepRulesRequest from 'owa-service/lib/contract/SetInboxAndSweepRulesRequest';
import InboxRule from 'owa-service/lib/contract/InboxRule';
import enableDisableInboxRuleRequest from 'owa-service/lib/factory/enableDisableInboxRuleRequest';
import setInboxAndSweepRulesRequest from 'owa-service/lib/factory/setInboxAndSweepRulesRequest';
import setInboxAndSweepRulesOperation from 'owa-service/lib/operation/setInboxAndSweepRulesOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { ObservableMap } from 'mobx';

/**
 * Helper method that creates the SetInboxAndSweepRulesRequest body
 * @param inboxRuleIds the list of inbox ruleIds in order
 * @param inboxRules the map that contains the inbox rule objects
 * @return EnableInboxRuleRequest
 */
function createRequestBody(
    inboxRuleIds: string[],
    inboxRules: ObservableMap<string, InboxRule>
): SetInboxAndSweepRulesRequest {
    let enableDisableRequests = [];
    inboxRuleIds.forEach(inboxRuleId => {
        let request = enableDisableInboxRuleRequest({
            Header: getJsonRequestHeader(),
            Identity: inboxRules.get(inboxRuleId).Identity,
            IsEnabled: inboxRules.get(inboxRuleId).Enabled,
        });
        enableDisableRequests.push(request);
    });
    return setInboxAndSweepRulesRequest({
        Header: getJsonRequestHeader(),
        EnableDisableInboxRules: enableDisableRequests,
    });
}

/**
 * Enable inbox rule service
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleResponse
 */
export default function setInboxAndSweepRulesService(
    inboxRuleIds: string[],
    inboxRules: ObservableMap<string, InboxRule>
): Promise<SetInboxAndSweepRulesResponse> {
    let requestBody = createRequestBody(inboxRuleIds, inboxRules);
    return setInboxAndSweepRulesOperation(requestBody);
}
